/**
 * 商品ギャラリー
 * scroll-snap のトラックを、サムネイルと前へ／次へで同じ位置へ動かす。
 * 1枚のときはトラック自体が無いので何もしない。
 */

(function () {
  'use strict';

  function initGallery(gallery) {
    const track = gallery.querySelector('.product-image__track');
    if (!track) return;

    const slides = Array.from(gallery.querySelectorAll('.product-image__slide'));
    const thumbs = Array.from(gallery.querySelectorAll('.product-image__item'));
    const prevBtn = gallery.querySelector('.product-image__nav--prev');
    const nextBtn = gallery.querySelector('.product-image__nav--next');
    if (!slides.length || !thumbs.length) return;

    const liveRegion = document.createElement('span');
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.setAttribute('aria-atomic', 'true');
    liveRegion.className = 'product-gallery__live-region';
    gallery.appendChild(liveRegion);

    thumbs.forEach((item, index) => {
      const img = item.querySelector('img');
      const altText = img ? img.alt : '';
      const label = altText ? `画像を表示: ${altText}` : `商品画像 ${index + 1}`;

      item.setAttribute('role', 'button');
      item.setAttribute('tabindex', '0');
      item.setAttribute('aria-label', label);
    });

    function getIndex() {
      const width = track.clientWidth;
      if (!width) return 0;
      return Math.round(track.scrollLeft / width);
    }

    function announce(index) {
      const img = slides[index] && slides[index].querySelector('img');
      const announcement = img && img.alt ? `表示中: ${img.alt}` : '画像を切り替えました';
      liveRegion.textContent = '';
      setTimeout(() => {
        liveRegion.textContent = announcement;
      }, 50);
    }

    // スクロール位置から今の枚数を出し、サムネイルと端のボタンを揃える
    function syncUi(index, shouldAnnounce) {
      const safeIndex = Math.max(0, Math.min(index, slides.length - 1));

      thumbs.forEach((el) => el.removeAttribute('aria-current'));
      if (thumbs[safeIndex]) {
        thumbs[safeIndex].setAttribute('aria-current', 'true');
      }

      if (prevBtn) prevBtn.hidden = safeIndex === 0;
      if (nextBtn) nextBtn.hidden = safeIndex === slides.length - 1;

      if (shouldAnnounce) announce(safeIndex);
    }

    function goTo(index, behavior) {
      const safeIndex = Math.max(0, Math.min(index, slides.length - 1));
      if (!slides[safeIndex]) return;

      // 各スライド幅はトラック幅と同じ。offsetLeft は position:relative の親基準なので使わない
      track.scrollTo({
        left: safeIndex * track.clientWidth,
        behavior: behavior || 'smooth'
      });
      syncUi(safeIndex, true);
    }

    thumbs.forEach((item, index) => {
      item.addEventListener('click', () => goTo(index));
      item.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        goTo(index);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', () => goTo(getIndex() - 1));
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => goTo(getIndex() + 1));
    }

    // スワイプ中は scroll、止まり切ったら scrollend。無いブラウザは scroll だけ
    let scrollTick = false;
    track.addEventListener('scroll', () => {
      if (scrollTick) return;
      scrollTick = true;
      requestAnimationFrame(() => {
        syncUi(getIndex(), false);
        scrollTick = false;
      });
    });
    track.addEventListener('scrollend', () => {
      syncUi(getIndex(), true);
    });

    gallery.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      if (event.target.closest('input, textarea, select')) return;
      event.preventDefault();
      goTo(getIndex() + (event.key === 'ArrowRight' ? 1 : -1));
    });

    syncUi(0, false);
  }

  function init() {
    document.querySelectorAll('[data-product-gallery]').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
